import { createSelector } from 'reselect';
import type { RootState } from '../root-reducer';

const payoutState = (state: RootState) => state.payout;

export const payoutSupportedCountriesSelector = createSelector(payoutState, s => s.supportedCountries);
export const payoutCountrySupportSelector = createSelector(payoutState, s => s.countrySupport);
export const payoutBanksByKeySelector = createSelector(payoutState, s => s.payoutBanksByKey);
export const payoutStripeConfigSelector = createSelector(payoutState, s => s.stripeConfig);
export const payoutVerifyResultSelector = createSelector(payoutState, s => s.verifyResult);
export const payoutVerifyingAccountSelector = createSelector(payoutState, s => s.verifyingAccount);
export const adminPayoutRequestsSelector = createSelector(payoutState, s => s.adminRequests);
export const adminPayoutPaginationSelector = createSelector(payoutState, s => s.adminPagination);
export const adminPayoutRequestsLoadingSelector = createSelector(payoutState, s => s.loadingAdminRequests);
export const processingAdminPayoutIdSelector = createSelector(payoutState, s => s.processingAdminPayoutId);
/** @deprecated use processingAdminPayoutIdSelector */
export const resolvingAdminPayoutIdSelector = processingAdminPayoutIdSelector;
